<script>
import { hasCurrentStoreAccess } from "@/mixins/store";

const ACCURACY_VALUES = [
  { text: "Digital scale", value: true },
  { text: "Estimate", value: false },
];

export default {
  name: "InventoryItemForm",
  mixins: [hasCurrentStoreAccess],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      valid: null,
      units: ["lbs", "oz", "g", "kg"],
      empty: " ",
      sts: false,
    };
  },
  computed: {
    ACCURACY_VALUES() {
      return [
        { text: "Digital scale", value: true },
        { text: "Estimate", value: false },
      ];
    },
    tags: {
      get() {
        return this.item.tags ? this.item.tags.split(",") : undefined;
      },
      set(newTags) {
        this.item.tags = newTags ? newTags.join(",") : undefined;
      },
    },
    accuracy: {
      get() {
        return !!this.item.estimated;
      },
      set(newEstimatedValue) {
        this.item.estimated = newEstimatedValue;
      },
    },
    store() {
      return this.currentStore;
    },
    formValid() {
      return !this.store.camraiConfig.requireLocation || !!this.item.location;
    },
  },
  watch: {
    "item.male": function (newVal, oldVal) {
      if (newVal) {
        if (this.store.brand == "PC") {
          if (!this.item.tags.includes("Guys")) this.item.tags.push("Guys");
        } else if (this.store.brand == "OUAC") {
          if (!this.item.tags.includes("Boys")) this.item.tags.push("Boys");
        }
        if (!this.item.tags.includes("Mens")) this.item.tags.push("Mens");
      } else {
        this.item.tags = this.item.tags.filter(
          (tag) => tag !== "Mens" && tag !== "Boys" && tag !== "Guys"
        );
      }
    },
    "item.female": function (newVal, oldVal) {
      if (newVal) {
        if (!this.item.tags.includes("Womens")) this.item.tags.push("Womens");
        if (!this.item.tags.includes("Girls")) this.item.tags.push("Girls");
      } else {
        this.item.tags = this.item.tags.filter(
          (tag) => tag !== "Girls" && tag !== "Womens"
        );
      }
    },
  },
};
</script>

<template>
  <v-container class="mt-4">
    <v-form ref="form" v-model="valid">
      <v-row>
        <v-col cols="12" class="py-0">
          <v-text-field
            v-model="item.title"
            autofocus
            label="Title"
            dense
            :placeholder="empty"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="py-0">
          <v-text-field
            v-model="item.desc"
            label="Description"
            dense
            :placeholder="empty"
          ></v-text-field>
        </v-col>
        <v-col cols="8" class="py-0 pr-1">
          <v-text-field
            v-model="item.location"
            label="Location"
            dense
            :placeholder="empty"
          ></v-text-field>
        </v-col>
        <v-col cols="4" class="py-0 pl-1">
          <v-text-field
            v-model="item.price"
            label="Price"
            prefix="$"
            dense
            :placeholder="empty"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="py-2">
          <v-combobox
            v-model="tags"
            dense
            label="Tags (optional)"
            multiple
            hint="Type something and press 'Enter' to add a tag"
          >
            <template v-slot:selection="{ item: selectItem, parent, selected }">
              <v-chip :input-value="selected" small>
                <span class="pr-2">
                  {{ selectItem }}
                </span>
                <v-icon
                  small
                  @click="parent.selectItem(selectItem)"
                  v-text="'$vuetify.icons.close'"
                >
                </v-icon>
              </v-chip>
            </template>
          </v-combobox>
        </v-col>
        <v-col cols="12" class="py-0">
          <v-text-field
            v-model="item.productType"
            label="Category"
            dense
            :placeholder="empty"
          ></v-text-field>
        </v-col>
        <v-col cols="6" class="pr-1 py-0">
          <v-text-field
            v-model="item.weight"
            label="Weight"
            dense
            :placeholder="empty"
          ></v-text-field>
        </v-col>
        <v-col cols="2" class="px-1 py-0">
          <v-select
            v-model="item.weightUnit"
            :items="units"
            placeholder="unit"
            dense
          ></v-select>
        </v-col>
        <v-col cols="4" class="pl-1 py-0">
          <v-select
            v-model="accuracy"
            :items="ACCURACY_VALUES"
            placeholder="accuracy"
            dense
          ></v-select>
        </v-col>
        <v-col cols="3" class="px-1 py-0">
          <v-checkbox v-model="item.male" label="Male" />
        </v-col>
        <v-col cols="3" class="px-1 py-0">
          <v-checkbox v-model="item.female" label="Female" />
        </v-col>
        <!-- <v-col cols="6" class="px-1 py-0">
          <v-switch v-if="!sts" v-model="sts" inset label="Send to shopify" />
        </v-col>-->
      </v-row>
    </v-form>
  </v-container>
</template>
